import { pageStyles, type PageStyle } from '@/theme/uboTheme';

const brandingSvgs: Record<string, string> = {
  merkidentiteit: '/ubo/merkidentiteit.svg',
  positionering: '/ubo/positionering.svg',
  strategie: '/ubo/strategie.svg',
  ontwikkelfase: '/ubo/ontwikkelfase.svg',
};

export default function BrandingImage({ style }: { style: PageStyle }) {
  if (!pageStyles[style]?.hasBranding) return null;
  const src = brandingSvgs[style];
  if (!src) return null;

  return (
    <div
      className="absolute -right-[15px] bottom-0 w-[300px] h-[300px] pointer-events-none"
      style={{ opacity: 0.08, filter: 'brightness(0) invert(1)' }}
    >
      <img
        src={src}
        alt=""
        className="page-chrome-image w-full h-full object-contain"
        onError={(e) => { e.currentTarget.style.display = 'none'; }}
      />
    </div>
  );
}
